var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serchProduct flex"},[_c('div',{staticClass:"btnText"},[_c('el-button',{attrs:{"type":"text"}},[_vm._v("最新产品")]),_c('el-button',{attrs:{"type":"text"}},[_vm._v("热门产品")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }